import React from 'react'
import styles from './ActionsGrid.module.scss'
import ActionCard from './ActionCard.tsx'
import { Action } from './HomeActions.tsx'

interface ActionsGridProps {
  actions: Action[]
  disableAnimations?: boolean
}

const ActionsGrid: React.FC<ActionsGridProps> = ({ actions, disableAnimations }) => {
  return (
    <div className={styles.gridContainer}>
      <div className={`${styles.grid} ${disableAnimations ? styles.gridStatic : ''}`}>
        {actions.map((action) => (
            <div key={action.id} className={disableAnimations ? styles.actionCardStatic : styles.actionCard}>
              <ActionCard action={action} />
            </div>
        ))}
      </div>
    </div>
  )
}

export default ActionsGrid
